import React from "react";

/**
 * Subtle organic divider between sections.
 */
export const SectionDivider = ({ flip = false, className = "" }) => (
    <div
        aria-hidden="true"
        className={`relative w-full ${flip ? "rotate-180" : ""} ${className}`}
    >
        <svg
            viewBox="0 0 1200 60"
            preserveAspectRatio="none"
            className="block h-10 w-full text-sand/70"
        >
            <path
                d="M0 30 Q300 60 600 30 T1200 30 L1200 60 L0 60 Z"
                fill="currentColor"
            />
        </svg>
    </div>
);

export default SectionDivider;
